export default function WilIntersectionObserver(fn, option) {
  if (!window.IntersectionObserver) {
    return undefined;
  }

  const defaultOption = {
    root: null,
    rootMargin: "0px",
    threshold: [0]
  };
  let callBacks = fn;

  const observerHandle = function (intersectionObserverEntrys) {
    intersectionObserverEntrys.forEach(intersectionObserverEntry => {
      callBacks.forEach(fn => {
        fn(intersectionObserverEntry);
      });
    });
  };

  const observer = new IntersectionObserver(observerHandle, Object.assign({}, defaultOption, option));
  return observer;
}
export * from './helper';